export const comments = [
  {
    id: "c1",
    postId: "1",
    author: "四楼常驻居民",
    school: "江城大学",
    content: "我就是天天在走廊加座的那种人，这次真的想给管理员鼓掌。位置是公共资源，不是私人储物柜。",
    time: "2026-09-09 21:14",
    likes: 1204,
  },
  {
    id: "c2",
    postId: "1",
    author: "考研倒计时87天",
    school: "江城大学",
    content: "理解执行条例，但笔记被一起收走真的会崩溃。希望下次至少给个提前通知，哪怕贴张纸也行。",
    time: "2026-09-09 22:02",
    likes: 638,
  },
  {
    id: "c3",
    postId: "1",
    author: "隔壁楼的旁观者",
    school: "明湖理工",
    content: "我们学校上学期也干过同样的事，效果出奇地好，一周之后四楼空座率肉眼可见地高了。",
    time: "2026-09-10 08:31",
    likes: 402,
  },
  {
    id: "c4",
    postId: "3",
    author: "磕到最后",
    school: "云麓师范大学",
    content: "追了三十天，本来以为是大团圆，看到女生的回复反而觉得这才是最好的结局。成年人的体面真的很难得。",
    time: "2026-09-07 23:40",
    likes: 1890,
  },
  {
    id: "c5",
    postId: "3",
    author: "理性吃瓜",
    school: "南岭大学",
    content: "连载式投稿确实容易给当事人压力，表白墙运营方后来的公告挺及时的，值得其他学校参考。",
    time: "2026-09-08 09:12",
    likes: 517,
  },
  {
    id: "c6",
    postId: "6",
    author: "同为双非",
    school: "白鹭财经大学",
    content: "三行复盘这个方法我记下了，之前每次面完就过去了，难怪同样的问题一直崩。",
    time: "2026-09-05 19:26",
    likes: 733,
  },
  {
    id: "c7",
    postId: "8",
    author: "路过的辅导员",
    school: "南岭大学",
    content: "那条群消息其实很关键，班长的一句中性发言把气氛从尴尬拉了回来。公示期最需要的就是这种表达。",
    time: "2026-09-02 20:55",
    likes: 406,
  },
  {
    id: "c8",
    postId: "11",
    author: "猫粮众筹发起人",
    school: "云麓师范大学",
    content: "补充一句，众筹账目我们每周在社团群里公开一次，全部用于猫粮和驱虫，欢迎随时来监督。",
    time: "2026-08-31 12:08",
    likes: 912,
  },
  {
    id: "c9",
    postId: "11",
    author: "刚入学的小白",
    school: "星洲学院",
    content: "这种帖子太治愈了，比纯八卦有意思多了。我们楼下也有只橘猫，明天就去问问能不能众筹。",
    time: "2026-08-31 15:44",
    likes: 355,
  },
  {
    id: "c10",
    postId: "9",
    author: "天天跑校园跑",
    school: "明湖理工",
    content: "骑车被误判的确实有，申诉只有两天太紧张了。规则可以严，但流程应该更友好一点。",
    time: "2026-09-01 17:20",
    likes: 289,
  },
];